import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RedirectCommand, ResolveFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { firstValueFrom } from 'rxjs/internal/firstValueFrom';
import { DistributionList, editDistributionListComplete, selectSelectedDistributionList } from '../store/communications';
import { CommunicationsApiService } from '../store/communications/communications-api.service';

const REDIRECT_URL = '/communications/distribution-lists';

export const DistributionListResolver: ResolveFn<DistributionList> | RedirectCommand = async (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const distributionListUId = route.paramMap.get('id');

  if (!distributionListUId) {
    return new RedirectCommand(router.parseUrl(REDIRECT_URL));
  }

  const store = inject(Store);

  const selectedDistributionList = store.selectSignal(selectSelectedDistributionList)();

  if (!!selectedDistributionList) {
    return selectedDistributionList;
  }

  const api = inject(CommunicationsApiService);

  const distributionList = await firstValueFrom(api.getDistributionList(distributionListUId)).catch(err => {
    console.warn(err);
    return null;
  });

  if (!distributionList) {
    return new RedirectCommand(router.parseUrl(REDIRECT_URL));
  }

  store.dispatch(editDistributionListComplete({ distributionList }));

  return distributionList;
};
